// @flow

export const gaPhrase = (ga: ?{ code: string, name: string }) => {
  if (!ga || (!ga.code && !ga.name)) return '-'
  const gaCode = !!ga.code ? ga.code : ''
  const gaName = !!ga.name ? ga.name : ''
  return `${gaCode} ${gaName}`.trim()
}
